import { z } from 'zod'
import { ElevatorTypes } from '../options'
import { AllElevatorSurveyFields } from './fields'

const ElevatorSurveyBase = z.object({
  timestamp: z.string().datetime(),
  metadata: z.object({
    timeToComplete: z.number(), // seconds
    formVersion: z.string(),
  }),
})

export const ElevatorSurveySchema = z.object({
  ...ElevatorSurveyBase.shape,
  elevatorType: z.enum(ElevatorTypes),
  ...AllElevatorSurveyFields.shape,
})

export const ElevatorSurveyPartialSchema =
  ElevatorSurveySchema.partial().required({
    elevatorType: true,
  })

// These are the same type for now, but we may want to separate them in the future
export type ElevatorSurvey = z.infer<typeof ElevatorSurveyPartialSchema>
